import {Divider} from '@mui/material';
import styled from 'styled-components';

const CustomDivider = styled(Divider)`
	margin-top: 8px;
`;

export {CustomDivider};
